import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import bannerImage01 from "../assets/main_bg01.png";
import bannerImage02 from "../assets/main_bg02.png";
import bannerImage03 from "../assets/main_bg03.png";
import bannerImage04 from "../assets/main_bg04.png";
import { getNowYear, SINCE_YEAR } from "./MainContents";

function Banner({ luseCount }) {
    const [luseYear, setLuseYear] = useState(0);
    const formattedCount = Number(luseCount).toLocaleString();
    const NOW_YEAR = getNowYear();

    useEffect(() => {
        setLuseYear(NOW_YEAR - SINCE_YEAR);
    }, []);

    return (
        <Carousel fade={true}>
            <Carousel.Item>
                <video
                    style={{ height: "650px", width: "100%", objectFit: "cover" }}
                    autoPlay={true}
                    controls={false}
                    loop
                    muted
                >
                    <source src="../assets/videos/1068196079-sd.mov" type="video/mp4" />
                    <img src={bannerImage03} alt="..." />
                </video>

                <Carousel.Caption>
                    <h2 className="text-white">
                        국내 최초 “인공지능 AI”를 활용한 “말로 하는 정비내역 입력”
                    </h2>
                    <p className="p-2 pb-5">
                        손 대신 말로 완성하는 정비내역, 입력 방식의 패러다임 전환<br />
                        하이웨이 모바일·AI 개발팀이 만든 스마트 정비 솔루션, 네오탭 공개
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <video
                    style={{ height: "650px", width: "100%", objectFit: "cover" }}
                    autoPlay={true}
                    controls={false}
                    loop
                    muted
                >
                    <source src="../assets/videos/1025767430-sd.mov" type="video/mp4" />
                    <img src={bannerImage03} alt="..." />
                </video>

                <Carousel.Caption>
                    <h2 className="text-white">
                        국내 최고 수준 최대 경력의 “IT 솔루션 개발팀” 보유
                    </h2>
                    <p className="p-2 pb-5">
                        {luseYear}년 축적된 노하우가 “하이웨이”를 업계 최고의 프로그램으로!
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <video
                    style={{ height: "650px", width: "100%", objectFit: "cover" }}
                    autoPlay={true}
                    controls={false}
                    loop
                    muted
                >
                    <source src="../assets/videos/1026842726-sd.mov" type="video/mp4" />
                    <img src={bannerImage03} alt="..." />
                </video>

                <Carousel.Caption>
                    <h2 className="text-white">
                        "ONLY" 자동차정비업계에서 유일한 “빅데이터 AI 인공지능팀”
                    </h2>
                    <p className="p-2 pb-5">
                        인공지능 AI를 활용하여 정확하고 신속한 데이터 정보를 지속적으로 개발<br />
                        자동차정비에 필요한 모든 공임 & 부품정보 구축 및 업데이트
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <video
                    style={{ height: "650px", width: "100%", objectFit: "cover" }}
                    autoPlay={true}
                    controls={false}
                    loop
                    muted
                >
                    <source src="../assets/videos/1068196079-sd.mov" type="video/mp4" />
                    <img src={bannerImage01} alt="..." />
                </video>

                <Carousel.Caption>
                    <h2 className="text-white">가장 오래된 기업. 정비업계와 동행한 No.1 솔루션 “하이웨이”</h2>
                    <p className="p-2 pb-5">
                        종합정비업 오토X, 전문정비업 프리미엄 네오 하이웨이, 고객과 함께하는 네오탭
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <video
                    style={{ height: "650px", width: "100%", objectFit: "cover" }}
                    autoPlay={true}
                    controls={false}
                    loop
                    muted
                >
                    <source src="../assets/videos/1025767430-sd.mov" type="video/mp4" />
                    <img src={bannerImage02} alt="..." />
                </video>

                <Carousel.Caption>
                    <h2 className="text-white">
                        “하이웨이” 서비스 네트워크가 업계 최고 수준의 고객서비스 실현
                    </h2>
                    <p className="p-2 pb-5">
                        전국 9개 지사 운영. AI 챗봇 및 온 & 오프라인 서비스 동시 지원 체계
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <video
                    style={{ height: "650px", width: "100%", objectFit: "cover" }}
                    autoPlay={true}
                    controls={false}
                    loop
                    muted
                >
                    <source src="../assets/videos/1054069406-sd.mov" type="video/mp4" />
                    <img src={bannerImage04} alt="..." />
                </video>

                <Carousel.Caption>
                    <h2 className="text-white">국내 정비업계 최다 설치 및 최장기간 솔루션 사용률 유지</h2>
                    <p className="p-2 pb-5">
                        {formattedCount}개 업체 사용으로 압도적인 “점유율 1위”
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

export default Banner;
